<template>
  <div class="list">
    <div class="select-searchmain2">
      <div class="earch-input">
        <div class="input-li">
          <p>企业名称</p>
          <el-input
            size="small"
            placeholder="请输入企业名称关键字"
            v-model="tableSearchParams.name"
          >
          </el-input>
        </div>
        <div class="input-li">
          <p>统一社会信用代码</p>
          <el-input
            size="small"
            placeholder="请输入企业名称关键字"
            v-model="tableSearchParams.code"
          >
          </el-input>
        </div>
        <div class="input-li">
          <p>选择辖区</p>
          <el-select
            style="width: 100%"
            size="small"
            filterable
            clearable
            v-model="tableSearchParams.jurisdiction"
            placeholder="请选择所在辖区"
          >
            <el-option
              v-for="item in jurisdiction"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </div>

        <div class="input-li">
          <p>行业类别</p>
          <el-cascader
            placeholder="请选择行业类别"
            ref="industryCas"
            size="small"
            clearable
            :show-all-levels="false"
            style="width: 100%"
            collapse-tags
            v-model="tableSearchParams.industry"
            :props="industriesProps"
            :options="industries"
            filterable
          >
          </el-cascader>
        </div>
        <div class="input-li">
          <p>联系人</p>
          <el-input
            size="small"
            placeholder="请输入联系人"
            v-model="tableSearchParams.wasteContact"
          >
          </el-input>
        </div>
        <div style="display: inline-block; margin-right: 20px">
          <p>查询日期</p>

          <el-date-picker
            size="small"
            :clearable="false"
            v-model="tableSearchParams.startYear"
            :picker-options="startDatePicker"
            value-format="yyyy"
            type="year"
            placeholder="开始时间"
          >
          </el-date-picker>
          ~
          <el-date-picker
            size="small"
            :clearable="false"
            v-model="tableSearchParams.endYear"
            :picker-options="endDatePicker"
            value-format="yyyy"
            type="year"
            placeholder="结束时间"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search-action">
        <el-button size="small" plain @click="onReset()">重置</el-button>
        <el-button size="small" type="primary" @click="getList()"
          >查询</el-button
        >
        <el-button size="small" @click="downloadTable()">下载</el-button>
      </div>
    </div>
    <el-table
      ref="mytable"
      v-loading="loading"
      size="small"
      height="calc(100% - 250px)"
      :header-cell-style="{
        background: '#f5f5f5',
        color: '#000',
      }"
      :data="dataSource"
      style="width: 100%; margin-bottom: 20px"
      row-key="companyId"
      border
    >
      <el-table-column align="center" label="序号" width="80">
        <template scope="scope">
          <span>{{
            (pagination.current - 1) * pagination.pageSize + scope.$index + 1
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="jurisdiction"
        width="80"
        label="所属辖区"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        width="200"
        label="企业名称"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span @click="detail(row)" class="company-name-link">{{
            row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="uniformSocialCreditCode"
        width="200"
        label="统一社会信用代码"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="industry2017s"
        width="200"
        label="行业类别"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column align="center" prop="wasteContact" label="联系人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="mobile"
        width="180"
        label="联系方式"
      >
      </el-table-column>
      <el-table-column
        align="center"
        :label="year + '年'"
        v-for="(greenVal, year) in yearCols"
        :key="year"
      >
        <el-table-column align="center" width="100" label="绿色指标">
          <template>
            {{ greenVal }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="150"
          label="年度万元产值（万元）"
        >
          <template slot-scope="{ row }">
            {{ findDataByYear(row.data, year)?.outPutValue || 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" width="120" label="危废产生量（吨）">
          <template slot-scope="{ row }">
            {{ findDataByYear(row.data, year)?.outPut || 0 }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div class="paaination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="pagination.pageSizeOptions"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <companyDetail ref="companyDetail"></companyDetail>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";
import { DownloadBlob } from "@/http/downloadService";
import companyDetail from "@/components/companyDetail.vue";

export default {
  components: { companyDetail },

  data() {
    return {
      loading: false,
      dataSource: [],
      tableSearchParams: {
        name: "",
        code: "",
        jurisdiction: null,
        industry: "",
        startYear: new Date().getFullYear() - 2 + "",
        endYear: new Date().getFullYear() - 1 + "",
      },
      startDatePicker: {
        disabledDate: (time) => {
          if (this.tableSearchParams.endYear) {
            return time.getFullYear() >= this.tableSearchParams.endYear;
          }
        },
      },
      endDatePicker: {
        disabledDate: (time) => {
          if (this.tableSearchParams.startYear) {
            return time.getFullYear() <= this.tableSearchParams.startYear;
          }
        },
      },
      yearCols: {},
      industriesProps: {
        multiple: false,
        value: "industryCode",
        label: "industryName",
        emitPath: false,
      },
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      jurisdiction: [],
      industries: [],
    };
  },
  methods: {
    downloadTable() {
      let url = this.$api.statistics.downloadGreenList;

      const data = this.tableSearchParams;
      DownloadBlob({
        url: url,
        data: data,
        method: "get",
      });
    },
    detail(row) {
      this.$refs.companyDetail.getCompanyInfo(row);
    },
    findDataByYear(data, year) {
      return data?.find((d) => d.year == year);
    },
    getList() {
      this.loading = true;

      const parames = {
        ...this.tableSearchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.statistics.getGreenList;
      this.$axios.get(url, parames, false).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          let { data, yearCols, total } = res.data.data;
          console.log(data);

          this.pagination.total = total;
          this.dataSource = data;

          this.yearCols = yearCols;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    getParams() {
      const url = this.$api.companies.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction, industries } = res.data.data;
          this.jurisdiction = jurisdiction;
          this.industries = industries;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.tableSearchParams = {
        name: "",
        code: "",
        jurisdiction: null,
        industry: "",
        startYear: new Date().getFullYear() - 2 + "",
        endYear: new Date().getFullYear() - 1 + "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getParams();
    this.getList();
  },

  updated() {
    this.$refs["mytable"].doLayout();
  },
};
</script>

<style lang="scss" scoped>
.company-name-link {
  color: #1890ff;
  cursor: pointer;
}
.list {
  height: 100%;
}

.select-searchmain2 {
  width: 100%;
  // height: 50px;
  display: flex;
  padding: 5px;
  box-sizing: content-box;

  .search-action {
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    height: 100%;
    margin-right: 10px;
    // line-height: 70px;
  }

  .earch-input {
    flex-grow: 1;
    // padding-left: 20px;

    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    .input-li2 {
      margin-right: 20px;
      width: 350px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }

    .input-li {
      margin-right: 20px;
      width: 200px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }
  }
}
</style>
